import VitalsCommonTable from "../../pages/app/provider/patient/patient-list/patient-chart-new/patient-visit-note/encounter/components/form-components/VitalsCommonTable";

interface VitalsBlockProps {
  data: any;
}

const VitalsBlock = ({ data }: VitalsBlockProps) => {
  return <VitalsCommonTable vitalsList={data?.patientVitals} />;
};

export default VitalsBlock;
